var viewportChecker = {
    selector: '*[data-viewport-checker="true"]:not(.visible)',
    init: function() {
        var self = this,
            $elements = $( self.selector );

        $elements.viewportChecker( {
            classToAdd: 'visible',
            classToAddForFullView: 'full-visible',
            classToRemove: 'invisible',
            removeClassAfterAnimation: false,
            invertBottomOffset: true,
            repeat: false,
            scrollHorizontal: false
        } );
    }
}

export { viewportChecker };
